<script setup lang="ts">
import { profileCard } from '../profile-card';
import { t } from '../i18n';
import Icon from './Icon.vue';
import ProfileAvatar from './ProfileAvatar.vue';

/** The access window's header: the module's mark, dots toward the person, then their picture. */
defineProps<{ name: string; logo?: string | null }>();
</script>

<template>
  <div class="bridge" data-access="bridge">
    <span class="ring" aria-hidden="true">
      <img v-if="logo" :src="logo" alt="" />
      <Icon v-else name="module" :size="26" />
    </span>
    <span class="dots" aria-hidden="true"><i v-for="n in 5" :key="n"></i></span>
    <span class="ring who" aria-hidden="true">
      <ProfileAvatar :id="profileCard.id" :first-name="profileCard.firstName || '?'" :last-name="profileCard.lastName" :avatar="profileCard.avatar" :size="69" />
    </span>
  </div>
  <p class="ask">{{ t('modules.accessAsk', { name }) }}</p>
</template>

<style scoped>
.bridge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 6px 0 2px;
}
.ring {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 1.5px solid color-mix(in srgb, var(--text) 42%, var(--border));
  display: grid;
  place-items: center;
  overflow: hidden;
  flex: none;
  background: var(--panel);
  color: var(--text-2);
}
.ring img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.dots {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dots i {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--text) 42%, var(--border));
}
.who {
  background: none;
}
.who :deep(.avatar) {
  width: 100%;
  height: 100%;
}
.ask {
  margin: 18px 0 0;
  font-size: 15px;
  line-height: 1.45;
  text-align: center;
}
</style>
